import { render } from "./Associa.vue?vue&type=template&id=5c43e164"
import script from "./Associa.vue?vue&type=script&lang=js"
export * from "./Associa.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__